import { useEffect, useState } from "react";
import { FaPhoneAlt, FaRegClock, FaSearch } from "react-icons/fa";
import FeedbackCarousel from "../components/FeedBackCarousel";
import { FiEye } from "react-icons/fi";
import { FaRegCalendar } from "react-icons/fa";
import { MdSpeed } from "react-icons/md";
import { BiGasPump } from "react-icons/bi";
import { LuMessageCircle } from "react-icons/lu";
import { FaCarAlt } from "react-icons/fa";
import { FaGear, FaLocationDot } from "react-icons/fa6";
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  onSnapshot,
  getDoc,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import app from "../firebase-config";
import { id_firebase } from "../content-site";
import { retiraMascara } from "../utils/retiraMascara";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FiltrosAvancados from "../components/FiltrosAvancados";
import BannerCarousel from "../components/BannersCarousel";
import { formatMoney } from "../utils/formatMoney";
import { Card, CardContent } from "../components/ui/Card";
import { FiShoppingCart as ShoppingCart, FiCreditCard as CreditCard } from "react-icons/fi";
import { FaAward as Award, FaUsers as Users } from "react-icons/fa";
import { useSearchParams } from "react-router-dom";
import { brands } from "../data/brands";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { Link } from "react-router-dom";
import { Bold } from "lucide-react";


const firestore = getFirestore(app);

export default function Home() {
  const [veiculos, setVeiculos] = useState([]);
  const [revenda, setRevenda] = useState({});
  const [filtros, setFiltros] = useState({ marca: "", modelo: "", ano: "" });
  const [filtrosAvancados, setFiltrosAvancados] = useState({
    tipo: "",
    cor: "",
    portas: "",
    kmMax: "",
    precoMin: "",
    precoMax: "",
  });

  const [searchParams] = useSearchParams();

  const marca = searchParams.get("vefipe_marca");

  const [, setErroFiltro] = useState("");

  const navigate = useNavigate();

  const [cars, setCars] = useState([]);


  useEffect(() => {
    window.scrollTo(0, 0);

    const revendaRef = doc(collection(firestore, "revenda"), id_firebase);
    getDoc(revendaRef).then((docSnap) => {
      if (docSnap.exists()) {
        setRevenda(docSnap.data());
      }
    });

    const q = query(
      collection(doc(collection(firestore, "revenda"), id_firebase), "veiculos"),
      where("veremovido", "==", 0),
      where("vevendido", "==", 0),
      orderBy("updated_at", "desc")
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const items = [];
      querySnapshot.forEach((doc) => {
        const document = doc.data();
        document.id = doc.id;
        if (document["veexibir_site"] !== false) {
          items.push(document);
        }
      });
      setVeiculos(items);
    });

    return () => unsubscribe();
  }, []);

  function getOpcoesFiltro(campo, marcaSelecionada = "") {
    const modelosFiltrados = veiculos.filter((veiculo) => {
      if (campo === "vefipe_name" && marcaSelecionada) {
        return veiculo.vefipe_marca === marcaSelecionada;
      }
      return true;
    });

    const opcoes = modelosFiltrados
      .map((veiculo) => veiculo[campo])
      .filter((valor, index, self) => valor && self.indexOf(valor) === index);

    return opcoes.sort();
  }

  const handleBuscar = () => {
    if (
      !filtros.marca &&
      !filtros.modelo &&
      !filtros.ano &&
      !Object.values(filtrosAvancados).some((value) => value)
    ) {
      setErroFiltro("Selecione pelo menos um filtro.");
      return;
    }

    const params = new URLSearchParams();
    // Mapeia os nomes dos filtros para os nomes dos campos do veículo
    if (filtros.marca) params.append("vefipe_marca", filtros.marca);
    if (filtros.modelo) params.append("vefipe_name", filtros.modelo);
    if (filtros.ano) params.append("vefipe_ano_modelo", filtros.ano);

    Object.entries(filtrosAvancados).forEach(([key, value]) => {
      if (value) {
        params.append(key, value);
      }
    });

    setErroFiltro("");
    navigate(`/estoque?${params.toString()}`);
  };

  function separarNomeVeiculo(nomeCompleto) {
    if (!nomeCompleto) return { mainName: '', subName: '' };

    const palavras = nomeCompleto.split(' ');

    const STOP_WORDS = [
      'CD', 'SR', 'SRV', 'GR', 'XEI', 'LTZ', 'LX',
      '4X4', '4X2',
      '1.0', '1.2', '1.3', '1.4', '1.5', '1.8', '1.6', '2.0', '2.8',
      'TDI', 'TURBO', 'DIESEL', 'FLEX',
      'AUT', 'AUT.', 'MT', 'CVT'
    ];

    const indexSpec = palavras.findIndex(p =>
      STOP_WORDS.includes(p)
    );

    if (indexSpec === -1) {
      return {
        mainName: palavras.slice(0, 2).join(' '),
        subName: palavras.slice(2).join(' ')
      };
    }

    return {
      mainName: palavras.slice(0, indexSpec).join(' '),
      subName: palavras.slice(indexSpec).join(' ')
    };
  }

  const filteorangeCars = cars.filter((car) =>
    marca ? car.brand === marca : true
  );

  return (
    <div className="min-h-screen w-full bg-zinc-900">
      <Header />

      {/* HERO */}
      <BannerCarousel />

      {/* TEXTO */}
      <section className="w-full flex flex-col items-center text-center mt-16 px-6">
        <h1 className="text-mega md:text-4xl font-extrabold mb-4 text-white">
          Alguma <span className="text-orange-600">marca</span> em mente?
        </h1>

        <p className="text-white sm:text-lg md:text-xl max-w-xl">
          Com um clique você encontra o carro ideal para seu negócio!
        </p>
      </section>

      {/* CARROSSEL DE MARCAS */}
     {/* <section className="w-full mt-12 px-6">
        <div className="max-w-[1200px] mx-auto">

          <Swiper
            modules={[Navigation]}
            navigation
            spaceBetween={32}
            slidesPerView={3}
            breakpoints={{
              640: { slidesPerView: 3 },
              768: { slidesPerView: 4 },
              1024: { slidesPerView: 5 },
              
            }}


          >
            {brands.map((brand) => (
              <SwiperSlide key={brand.slug} className="flex justify-center ">
                <Link
                  to={`/estoque?vefipe_marca=${brand.slug}`}
                  className="group flex items-center justify-center h-32"
                >
                  <img
                    src={brand.logo}
                    alt={brand.name}
                    className="
                    h-12 md:h-24
                    object-contain
                    opacity-60
                    grayscale
                    transition-all
                    duration-300
                    group-hover:opacity-100
                    group-hover:grayscale-0
                    group-hover:scale-105
                   
                  "
                  />
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section >*/}

      <section className="py-20">
        <div className="container mx-auto px-4">

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <Card className="border-2 hover:border-primary hover:shadow-lg transition-all duration-300 h-[350px] bg-black border-orange-600">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <ShoppingCart className="text-orange-500" size={32} />
                </div>
                <h3 className="text-xl font-bold mb-3 text-white">Veículos de todas as categorias!</h3>
                <p className="text-white leading-relaxed">
                  Ache o veículo ideal e saia com a chave em mãos!
                </p>
              </CardContent>
            </Card>

            <Card className="border-2 hover:border-primary hover:shadow-lg transition-all duration-300 h-[350px] bg-black border-orange-600">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <CreditCard className="text-orange-500" size={32} />
                </div>
                <h3 className="text-xl font-bold mb-3 text-white">Condições Comerciais Especiais</h3>
                <p className="text-white leading-relaxed">
                  Preços competitivos, volume facilitado e condições pensadas para o seu negócio
                </p>
              </CardContent>
            </Card>

            <Card className="border-2 hover:border-primary hover:shadow-lg transition-all duration-300 h-[350px] bg-black border-orange-600">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Award className="text-orange-500" size={32} />
                </div>
                <h3 className="text-xl font-bold mb-3 text-white">Procedência Garantida</h3>
                <p className="text-white leading-relaxed">
                  Veículos com total segurança, documentação regular e origem confiável
                </p>
              </CardContent>
            </Card>

            <Card className="border-2 hover:border-primary hover:shadow-lg transition-all duration-300 h-[350px] bg-black border-orange-600">
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Users className="text-orange-500" size={32} />
                </div>
                <h3 className="text-xl font-bold mb-3 text-white">Atendimento B2B Especializado</h3>
                <p className="text-white leading-relaxed">
                  Consultores focados em revenda para agilizar negociações e reposição de estoque
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <div className="relative flex flex-col items-center justify-center text-white text-center px-2 sm:px-4">
        <h1 className="text-3xl sm:text-4xl md:text-6xl mt-8 font-bold mb-2 sm:mb-4">Carros em <span className="text-orange-500">Destaque</span>
        </h1>
        <p className="text-gray-400 sm:text-lg md:text-xl mb-4 sm:mb-8">
          Confira nossa seleção de veículos premium disponíveis para você
        </p>


      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mt-6 max-w-6xl mx-auto px-4">
        {veiculos
          .slice()
          .sort(() => Math.random() - 0.5)
          .slice(0, 3)
          .map((veiculo) => {

            const { mainName, subName } = separarNomeVeiculo(
              veiculo.vefipe_name
            );

            const cambio = veiculo.vecambio === 'A' ? 'Automático' : veiculo.vecambio === 'M' ? 'Manual' : veiculo.vecambio;

            veiculo.vecambio = cambio;

            return (
              <div key={veiculo.id} className="bg-black rounded-xl shadow-lg overflow-hidden flex flex-col h-[110%]">
                <img className="object-contain w-full h-48 md:h-64 lg:h-72" src={veiculo.imagens[0]?.fileUrl} alt={veiculo.titulo} />

                <div className="p-4 flex-1 flex flex-col justify-between">
                  <div>
                    <h3 className="text-lg font-bold uppercase text-white">
                      {veiculo.vefipe_marca} {mainName}
                    </h3>

                    {subName && (
                      <p className="text-sm text-gray-400 uppercase">
                        {subName}
                      </p>
                    )}
                  </div>

                  <div className="grid grid-cols-2 text-white space-y-2 text-sm">
                    <span className="flex items-center gap-1">
                      <MdSpeed /> {veiculo.vequilometragem}km
                    </span>
                    <span className="flex items-center gap-1">
                      <BiGasPump /> {veiculo.vefipe_combustivel}
                    </span>
                    <span className="flex items-center gap-1">
                      <FaRegCalendar /> {veiculo.veano_fabricacao} / {veiculo.vefipe_ano_modelo}
                    </span>
                    <span className="flex items-center gap-1">
                      <FaGear /> {veiculo.vecambio}
                    </span>
                  </div>

                  <hr className="text-gray-600" />
                  <div className="mt-2 flex gap-4 items-center justify-between">
                    <p className="text-xl font-bold text-orange-600">
                      {veiculo.vevalor
                        ? formatMoney(veiculo.vevalor)
                        : 'Consulte o preço'}
                    </p>


                    <a
                      href={`/veiculo/${veiculo.id}`}
                      className="bg-orange-600 text-white px-4 py-2 rounded flex gap-2 items-center"
                    >
                      <FiEye /> Ver Detalhes
                    </a>

                  </div>
                </div>
              </div>
            );
          })}

      </div>
      <section className="my-20">
        <FeedbackCarousel />
      </section>


      <Footer /> 
    </div >
  );
}